import { render, staticRenderFns } from "./VersionTaskFilter.vue?vue&type=template&id=ff6f05fe&scoped=true"
import script from "./VersionTaskFilter.vue?vue&type=script&lang=js"
export * from "./VersionTaskFilter.vue?vue&type=script&lang=js"
import style0 from "./VersionTaskFilter.vue?vue&type=style&index=0&id=ff6f05fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6f05fe",
  null
  
)

export default component.exports